<template>
  <div class="container">
    <div class="search cf">
      <Form ref="formItem" inline :model="formItem" :label-width="100">
        <div class="searchDiv">
          <!-- <FormItem v-if="this.formItem.unitNameCHN" label="赛事单位：" prop="unitNameCHN" >
                      {{this.formItem.unitNameCHN}}
          </FormItem> -->
          <FormItem label="赛事单位：" prop="unitNameCHN">
            <Select v-model="formItem.unitNameCHN" placeholder="全部">
              <Option value="">全部</Option>
              <Option v-for="(item, index) in formInfo.unitList" :value="item.unitNameCHN" :key="index">
                {{ item.unitNameCHN }}</Option>
            </Select>
          </FormItem>
          <FormItem label="组别：" prop="unitNameCHN">
            <Select v-model="formItem.sortNameCHN" placeholder="全部">
              <Option value="">全部</Option>
              <Option v-for="(item, index) in formInfo.sortList" :value="item.sortNameCHN" :key="index">
                {{ item.sortNameCHN }}</Option>
            </Select>
          </FormItem>
          <FormItem label="项目：" prop="event">
            <Select v-model="formItem.event" placeholder="全部">
              <Option value="">全部</Option>
              <Option v-for="(item, index) in formInfo.eventList" :value="item.event" :key="index">{{ item.event }}
              </Option>
            </Select>
          </FormItem>
          <FormItem style="width:210px;" label="姓名：" prop="familyNameCHN">
            <Input placeholder="输入姓名" v-model="formItem.familyNameCHN"></Input>
          </FormItem>
          <FormItem label="性别：" prop="sex">
            <Select v-model="formItem.sex" placeholder="全部" clearable>
              <Option v-for="(item, index) in sexData" :value="item.value" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem style="width:220px;" label="身份证号：" prop="iDCard">
            <Input placeholder="输入身份证号码" v-model="formItem.iDCard"></Input>
          </FormItem>
          <FormItem style="width:210px;" label="注册号：" prop="registerNo">
            <Input placeholder="输入注册号" v-model="formItem.registerNo"></Input>
          </FormItem>
          <FormItem label="证书是否存在：">
            <Select v-model="awardPictureState" placeholder="请选择证书是否存在" clearable>
              <Option label="存在" value="1"></Option>
              <Option label="不存在" value="0"></Option>
            </Select>
          </FormItem>
          <Button type="primary" @click="searchSubmit" icon="ios-search">搜索</Button>
          <Button type="primary" @click="refresh('formItem')" icon="md-refresh">重置</Button>
          <!-- <Button type="info" @click="printF()" icon="ios-print-outline" >打印</Button> -->
        </div>
      </Form>
    </div>
    <div class="sportsTi">
      <h3>{{ title }}<span>（ 请使用谷歌浏览器打印 ）</span></h3>
      <div>
        <Button type="primary" @click="returnAllJZ">
          <Icon type="md-cloud-download" /> 导出全部奖状
        </Button>
        <router-link class="display-i" to="/List">
          <Button type="info" icon="md-return-left">返回赛事列表</Button>
        </router-link>

      </div>
    </div>

    <div class="printTableList">
      <Table stripe border :columns="registerColumns" :data="registerData" @on-selection-change="checkBoxs"></Table>
    </div>
    <Page :total="total_record" :page-size="formItem.page_size" class="sportermeetingPage" :current="formItem.page_no"
      @on-change="changepage" show-elevator show-total placement="top" />
    <Modal id="printTestBox" title="打印获奖证书" width="1000" v-model="printVisible">
      <div ref="printTest" id="dialogCare" class="printTest">
        <div v-for="(item, index) in certificateImg" :key="index">
          <img :src="item.awardPictureRealURL" alt="">
        </div>
      </div>
    </Modal>
    <Modal :footerHide="true" title="导出全部奖状" v-model="allZsModal">
      <div>
        <Form ref="formItem" inline :model="formItem" :label-width="72">
          <FormItem label="导出模式：">
            <Select v-model="mode" placeholder="全部">
              <Option :value="0">单位区分</Option>
              <Option :value="1">项目区分</Option>
            </Select>
          </FormItem>
        </Form>
        <div class="UpBut">
          <Button type="primary" size="large" @click="downZipF()">导出</Button>
        </div>
      </div>
    </Modal>
    <Modal title="获奖证书" width="700" v-model="printVisibleImg">
      <div class="printTest">
        <img width="100%" :src="awardPictureRealURL" alt="">
      </div>
    </Modal>
    <iframe :src="fileUrl" style="overflow:hidden;height:0px;width:0;" frameborder="0"></iframe>
  </div>
</template>

<script>
import {
  findPageBy,
  findQueryParame,
  currentTimes,
  downZip,
  getCorporationList,
} from "@/lib/api/index.js";
import Vue from "vue";
import Print from "@/lib/utils/print";
Vue.use(Print); // 注册
export default {
  data() {
    return {
      awardPictureRealURL: "",
      returnAllJZData: "",
      mode: 0,
      stampTiem: 0, //当前时间戳
      title: "", //赛事标题
      certificateImg: [],
      printVisibleImg: false,
      printVisible: false,
      imgCode: "",
      multipleSelection: [],
      loginBox: true,
      authorities: [],
      pageid: "",
      gameNameCHN: "",
      formInfo: {
        eventList: [],
        sortList: [],
        unitList: [],
      },
      total_record: 0, //总条数
      fileUrl: "",
      allZsModal: false,
      awardPictureState: "",
      sexData: [
        {
          name: "混合",
          value: 2,
        },
        {
          name: "男",
          value: 0,
        },
        {
          name: "女",
          value: 1,
        },
      ],
      formItem: {
        page_no: 1,
        page_size: 10,
        // property: 1,
        gameID: "",
        sex: "",
        event: "",
        iDCard: "",
        registerNo: "",
        familyNameCHN: "",
        unitNameCHN: "",
        registerUnitName: "",
        awardCode: "",
      },
      registerColumns: [
        {
          type: "selection",
          width: 40,
          align: "center",
        },
        {
          title: "名次",
          key: "splace",
          width: 60,
        },
        {
          title: "单位",
          key: "unitNameCHN",
        },
        {
          title: "项目",
          key: "event",
          render: (h, params) => {
            return h("div", params.row.sexSortName + "--" + params.row.event);
          },
        },
        {
          title: "赛次",
          key: "layer",
          render: (h, params) => {
            let texts = "";
            if (params.row.property === 2 || params.row.property === 3) {
              if (params.row.layer === 0) {
                texts = "及格赛";
              } else if (params.row.layer === 1) {
                texts = "决赛";
              } else if (params.row.layer === 4) {
                texts = "颁奖";
              }
            } else if (params.row.property !== 5) {
              if (params.row.layer === 0) {
                texts = "预赛";
              } else if (params.row.layer === 1) {
                texts = "次赛";
              } else if (params.row.layer === 2) {
                texts = "半决赛";
              } else if (params.row.layer === 3) {
                texts = "决赛";
              } else if (params.row.layer === 4) {
                texts = "颁奖";
              }
            }

            return h("div", texts);
          },
        },
        {
          title: "姓名",
          key: "familyNameCHN",
        },
        {
          title: "成绩",
          key: "showResult",
        },

        {
          title: "操作",
          align: "center",
          width: 190,
          render: (h, params) => {
            return h("div", {}, [
              h(
                "Button",
                {
                  props: {
                    type: "info",
                    size: "small",
                  },
                  style: {
                    display:
                      params.row.awardPictureRealURL
                        ? "inline-block"
                        : "none",
                    marginRight: "6px",
                  },
                  on: {
                    click: () => {
                      this.certificateImg = [];
                      this.certificateImg.push({
                        awardPictureRealURL:
                          this.$imgUrl +
                          "/api/resources/respource?path=" +
                          params.row.awardPictureRealURL,
                      });
                      this.parintCertificateF();
                    },
                  },
                },
                "打印"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small",
                  },
                  style: {
                    marginRight: "6px",
                    display:
                      params.row.awardPictureRealURL
                        ? "inline-block"
                        : "none",
                  },
                  on: {
                    click: () => {
                      let time = new Date().getTime();
                      this.fileUrl = `${this.$imgUrl}/api/resources/respource?path=${params.row.awardPictureRealURL}&isDownload=true&time=${time}`;
                    },
                  },
                },
                "下载"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small",
                    type: "info",
                  },
                  style: {
                    display:
                      params.row.awardPictureRealURL
                        ? "inline-block"
                        : "none",
                  },
                  on: {
                    click: () => {
                      let time = new Date().getTime();

                      this.printVisibleImg = true;
                      this.awardPictureRealURL = `${this.$imgUrl}/api/resources/respource?path=${params.row.awardPictureRealURL}&isDownload=true&time=${time}`;
                    },
                  },
                },
                "查看"
              ),
            ]);
          },
        },
      ],
      registerData: [],
    };
  },
  methods: {
    print(obj) {
      let endT = 1000 * 3600 * 24 + obj.endTime;
      let beginT = 1000 * 3600 * 24 + obj.beginTime;
      let timestamp = this.stampTiem;
      let end = timestamp - 1000 * 3600 * 24 * 180;
      let begin = timestamp - 1000 * 3600 * 24 * 183;
      let state = false;
      if (localStorage.unitType == "0") {
        state = timestamp < obj.beginTime ? false : true;
      } else {
        state = timestamp < endT || obj.endTime < end ? false : true;
      }
      return state;
    },
    parintCertificateF() {
      const userAgent = navigator.userAgent;
      setTimeout(() => {
        if (this.isIE() || userAgent.indexOf("Edge") !== -1) {
          this.printpage("dialogCare");
        } else {
          this.$print(this.$refs.printTest);
        }
      }, 200);
    },
    printF() {
      if (this.multipleSelection.length == 0) {
        this.$Message.error("请至少选择一项再操作");
      } else {
        this.certificateImg = [];
        this.multipleSelection.map((item) => {
          if (item.awardPictureRealURL) {
            this.certificateImg = [
              {
                awardPictureRealURL:
                  this.$imgUrl +
                  "/api/resources/respource?path=" +
                  item.awardPictureRealURL,
              },
            ];
            this.parintCertificateF();
          }
        });
      }
    },
    printpage(myDiv) {
      var newstr = document.getElementById(myDiv).innerHTML;
      var oldstr = document.body.innerHTML;
      document.body.innerHTML = newstr;
      window.print();
      document.body.innerHTML = oldstr;
      window.location.reload();
      return false;
    },
    refresh(name) {
      this.$refs[name].resetFields();
    },
    //分页方法
    changepage(value) {
      this.formItem.page_no = value;
      this.searchSubmit(value);
    },
    // 点击复选框回调
    checkBoxs(val) {
      this.multipleSelection = val; // 返回的是选中的列的数组集合
    },
    back() {
      this.$router.go(-1); //返回上一层
    },
    isIE() {
      if (!!window.ActiveXObject || "ActiveXObject" in window) {
        return true;
      } else {
        return false;
      }
    },
    searchSubmit(v) {
      if (typeof v !== "number") {
        this.formItem.page_no = 1;
      }
      if (this.formItem.gameID) {
        if (this.awardPictureState === "1") {
          this.formItem.awardPictureState = true;
        } else if (this.awardPictureState === "0") {
          this.formItem.awardPictureState = false;
        } else {
          this.formItem.awardPictureState = "";
        }
        findPageBy(this.formItem).then(
          (res) => {
            if (res.data.code == 0) {
              if (res.data.data.records.length) {
                this.registerData = res.data.data.records;
                this.total_record = parseInt(res.data.data.total);
              } else {
                this.registerData = [];
                this.total_record = 0;
              }
            } else if (res.data.code == -2) {
              this.$Message.error("获取失败");
            } else if (res.data.code == 10) {
              this.$Message.info("登录token过期请重新登录");
              this.$store.dispatch("loginOut");
            } else {
              this.$Message.error(res2.data.msg);
            }
          },
          (err) => {
            this.$Message.error("网络连接失败");
          }
        );
      } else {
        this.$Message.error("缺少gameID参数");
      }
    },
    returnAllJZ() {
      if (JSON.parse(localStorage.authorities) == this.$PlugIn.role.admin) {
        this.returnAllJZData = `gameId=${this.formItem.gameID}&mode=${this.mode}`;

        this.allZsModal = true;
      } else {
        this.returnAllJZData = `gameId=${this.formItem.gameID}&unitName=${localStorage.unitName ? localStorage.unitName : ""
          }`;
        this.downZipF();
      }
    },
    downZipF() {
      this.loadings("正在导出中，请稍后...");

      downZip(this.returnAllJZData).then(
        (res) => {
          let elink = document.createElement("a");
          let blob = new Blob([res.request.response], {
            type: "application/zip",
          });
          let dateTime = this.$PlugIn.formatDateTime(new Date());
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          elink.setAttribute("download", "奖状" + dateTime + ".zip");
          document.body.appendChild(elink);
          elink.click();
          document.body.removeChild(elink);
          this.allZsModal = false;
          this.$Spin.hide();
        },
        (err) => {
          this.$Message.error("网络连接失败");
          this.$Spin.hide();
        }
      );
    },
  },
  created() {
    this.formItem.gameID = this.$route.query.gameID
      ? this.$route.query.gameID
      : "";
    this.title = this.$route.query.title
      ? decodeURI(this.$route.query.title)
      : "";

    this.formItem.unitNameCHN = localStorage.unitName
      ? localStorage.unitName
      : "";

    findQueryParame(this.formItem.gameID).then((res) => {
      if (res.data.code == 0) {
        this.formInfo = res.data.data;
      }
    });


    currentTimes()
      .then((res) => {
        if (res.data.code === 0) {
          this.stampTiem = parseInt(res.data.data);
        } else {
          this.$Message.warning("网络请求已经超时，请重新刷新页面");
        }
      })
      .catch((error) => { });
    this.searchSubmit();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.container {
  min-height: 62vh;
}

.printTest>div {
  text-align: center;
  height: 595px;
  width: 842px;
}

.printTest img {
  width: 100%;
}

.sportsTi {
  overflow: hidden;
  padding-bottom: 12px;

  h3 {
    font-size: 15px;
    font-weight: normal;
    float: left;
  }

  span {
    color: #999;
    font-weight: normal;
  }

  div {
    float: right;
  }
}

.printTableList {
  padding-bottom: 32px;
}
</style>



// WEBPACK FOOTER //
// src/view/printCertificate.vue